import TermsOfServicePage from "pages/legal/TermsOfServicePage";
import React from "react";

const TermsOfServiceRoute = () => <TermsOfServicePage />;

export default TermsOfServiceRoute;
